import React, { useState, useEffect } from 'react';
import { Info } from 'lucide-react';

const VersionInfo = () => {
  const [backendVersion, setBackendVersion] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  // Get frontend version from package.json
  const packageJson = require('@src/../../package.json');
  const frontendVersion = packageJson.version || '1.0.0';

  useEffect(() => {
    // Fetch backend version
    const fetchBackendVersion = async () => {
      try {
        // Use /api/v1/version to match nginx routing expectations
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
        const response = await fetch(`${apiUrl}/api/v1/version`);
        if (response.ok) {
          const data = await response.json();
          setBackendVersion(data);
        }
      } catch (error) {
        console.error('Failed to fetch backend version:', error);
      }
    };

    fetchBackendVersion();
  }, []);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {/* Version Info Button */}
      <button
        onClick={toggleVisibility}
        className="bg-gray-600 hover:bg-gray-700 text-white p-2 rounded-full shadow-lg transition-colors"
        title="Version Information"
      >
        <Info size={16} />
      </button>

      {/* Version Info Panel */}
      {isVisible && (
        <div className="absolute bottom-12 right-0 bg-white border border-gray-300 rounded-lg shadow-lg p-4 min-w-64">
          <div className="text-sm space-y-2">
            <div className="font-semibold text-gray-800 border-b pb-2">
              Version Information
            </div>

            <div className="space-y-1">
              <div className="flex justify-between">
                <span className="text-gray-600">Frontend:</span>
                <span className="font-mono text-blue-600">{frontendVersion}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Backend:</span>
                <span className="font-mono text-green-600">
                  {backendVersion ? backendVersion.version : 'Loading...'}
                </span>
              </div>
            </div>

            {backendVersion && (
              <div className="pt-2 border-t text-xs text-gray-500">
                <div>Build: {backendVersion.build_time}</div>
                <div>Commit: {backendVersion.git_commit.substring(0, 8)}</div>
                <div>Go: {backendVersion.go_version}</div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default VersionInfo;
